import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import Sdk from 'kts-platform-frame/appSdk';
import { MyStore, reducers } from 'kts-platform-frame/redux';
import AppSdk from 'kts-platform-frame/appSdk';
import { Spin } from 'antd';

const css = require('./index.scss');
/** Redux接口 */
interface IReduxStatePart {
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    componentDidMount() {
        const { user } = MyStore.instance.getState();
        // 当前公司id
        const userCompanyId = user.userInfo.companyId;
        // 路由公司
        const companyId = this.props.match.params.companyId;
        const toCompanyId = this.props.match.params.toCompanyId;
        // 需要跳转到对方公司查看
        const detailCompanyId = userCompanyId !== companyId ? companyId : toCompanyId;
        this.props.history.replace(`/workbench/platform/network/userlist/companyDetail/${detailCompanyId}`);
        // AppSdk.instance.openApp(this, {
        //     appKey: 'Kingxunlian.Network',
        //     openType: 1,
        //     routing: `companyDetail/${detailCompanyId}`,
        // });

    }
    render() {
        return (
            <div className={css.chatVerification}>
                <Spin />
            </div>  
        );
    }
}



// WEBPACK FOOTER //
// ./src/display/platform/Network/UI.Chat.Verification.tsx